import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    success: 'Success',
    stakeDescription:
      'Your IOTA sucessfully staked. stIOTA was sent your wallet.',
    stakedValue: 'You successfully staked {value} {nativeToken}.',
    justSentValue: '{value} just {stakedToken} sent to your wallet.',
    close: 'Close',
    exploreOpportunities:
      'Explore DeFi opportunities for your {stakedToken} to earn more.',
    pools: 'Pools finance',
    exploreStrategies: 'OK',
  },
};
